import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import LoadUnloadService from '../../services/LoadUnloadService';
import { translate, isNullOrEmpty } from '../../utils/util';
import { RadioButton, Title } from '../../components/UI/ComponentsUI';
import BackButton from '../../components/UI/BackButton';
import CardUI from '../../components/UI/CardUI';
import SelectNew from '../../components/UI/SelectNew';
import { onValueChange } from '../../utils/handleChangeHooks';

const ShedConfig = (props) => {
    const [model, setModel] = useState({ shed: props.shed || '', movementType: props.movementType });
    const [movementTypes, setMovementTypes] = useState();

    useEffect(() => {
        props.loadSheds(() => {
            props.loadShedConfigs();
        });
    }, []);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const changeConfirmOption = async (shedId, shedCode, movementTypeId, value) => {
        props.saveShedsConfig(shedId, shedCode, movementTypeId, value);
    }

    const filterMovementsType = (shed) => {
        if (!isNullOrEmpty(shed) && props?.sheds) {
            var data = props?.sheds.find(f => f.id === parseInt(shed))?.movementTypes
            setMovementTypes(data);
        } else {
            setMovementTypes([])
        }
    }

    return (

        <div>
            <BackButton {...props} />
            <div className="h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-list-outline" label={translate("shedConfigTitle", "load-unload")} />
                </div>
            </div>


            <div style={{ paddingLeft: '15px', paddingRight: '15px', marginTop: '-20px' }}>
                <i className='mdi mdi-information-variant-circle-outline' style={{ marginRight: 5 }} />
                {translate("shedConfigInfo", "load-unload")}
            </div>

            <div className="container-fluid">
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div>
                                <form id="formLoadUnloadConfig" className="col s12">
                                    <div className="row" style={{ marginBottom: '0px' }}>

                                        <div className="input-field col s12" style={{ marginTop: 'auto' }}>
                                            <SelectNew
                                                required
                                                id={'shed'}
                                                name="shed"
                                                label={translate('shed', 'physical-confirmation')}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                data={props?.sheds ? props.sheds.map((i) => {
                                                    return { id: i.id, text: i.code };
                                                }) : []} value={model.shed}
                                                change={(evt) => {
                                                    onChange(evt);
                                                    filterMovementsType(evt.target.value);
                                                }}
                                            />
                                        </div>
                                        <div className="input-field col s12">
                                            <SelectNew
                                                required
                                                id={'movementType'}
                                                name="movementType"
                                                label="Tipo Movimentação"
                                                placeHolder={translate('choose-one-option', 'general')}
                                                data={movementTypes?.map((i) => {
                                                    return { id: i.movementType.id, text: i.movementType.description };
                                                })}
                                                value={model.movementType || ''}
                                                change={(e) => {
                                                    onChange(e);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {(!(model?.shed && model?.movementType)) ? <></> :
                <div className="container" style={{ marginTop: '80px' }}>
                    <CardUI style={{ paddingBlockEnd: '5px' }} key="shedConfigs">

                        <div className="row" style={{ marginBottom: '0px', clear: 'both' }}>
                            <div className="col s7">
                                <div>{translate('shed', 'load-unload')}</div>
                            </div>
                            <div className="col s3 center">
                                <div>{translate('confirmInLogistics', 'load-unload')}</div>
                            </div>
                            <div className="col s2 center">
                                <div>{translate('confirmInAe', 'load-unload')}</div>
                            </div>
                        </div>

                        {props.shedConfigs?.filter((item) => item.shedId === Number(model.shed) && item.movementTypeId === Number(model.movementType)).map((item, index) => {
                            return <div
                                key={`key_${item.shedCode}_${item.movementType}`}
                                className="collection-item"
                                style={{ display: 'block', padding: '5px 0' }}>
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="col s7">
                                        <div>{`${item.shedCode || ''} - ${item.movementType}`}</div>
                                    </div>
                                    <div className="col s3 center">
                                        <RadioButton
                                            name={`shed_${item.shedCode}_${item.movementType}_0`}
                                            onChange={(e) => { changeConfirmOption(item.shedId, item.shedCode, item.movementTypeId, Number(e.target.value)) }}
                                            defaultChecked={item.indConfirmCargoInAe ? 1 : 0}
                                            items={[
                                                { id: 0, label: '' }
                                            ]}
                                        />
                                    </div>
                                    <div className="col s2 center">
                                        <RadioButton
                                            name={`shed_${item.shedCode}_${item.movementType}_1`}
                                            onChange={(e) => { changeConfirmOption(item.shedId, item.shedCode, item.movementTypeId, Number(e.target.value)) }}
                                            defaultChecked={item.indConfirmCargoInAe ? 1 : 0}
                                            items={[
                                                { id: 1, label: '' },
                                            ]}
                                        />
                                    </div>
                                </div>
                            </div>
                        })}
                    </CardUI>
                </div>}
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        sheds: state.loadUnloadReducer.sheds,
        shedConfigs: state.loadUnloadReducer.shedConfigs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadSheds: (callback) => {
            dispatch(LoadUnloadService.getShedsLoad(callback));
        },
        loadShedConfigs: (callback) => {
            dispatch(LoadUnloadService.getShedsConfig(callback, true));
        },
        saveShedsConfig: (shedId, shedCode, movementTypeId, indConfirmCargoInAe, callback) => {
            dispatch(LoadUnloadService.saveShedsConfig(shedId, shedCode, movementTypeId, indConfirmCargoInAe, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShedConfig));
